//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

//#region Angular Imports

import { StateService } from '@uirouter/angularjs'

//#endregion

import { Api, LocalDictionaryFactory } from './../api/api.module'
import { ColumnModel } from '../api/api.models'

import { BaseGridController, ScopeBaseGrid } from '../common/common.base.grid.controller'
import { ButtonsOptions } from '../common/grid/grid.controller'
import { CreateEditInitParams, BulkEditInitParams } from '../common/create-edit-popup/create-edit-popup.controller'
import { DetailsOptions } from '../common/details-popup/details-popup.directive'
import { GridTypes, GridController } from '../common/grid/grid.controller'
import { ImportOptions } from '../common/import/import.directive'
import { LoggerService } from './../common/common.module'
import { i18n } from '../common/i18n/common.i18n'

import { CommonHelper } from '../../helpers/common-helper'
import { EventsNames } from '../../helpers/events-names'
import { UserSessionService } from '../../services/user-session'
import { SystemService } from '../../services/system'

import { Enums } from '../../models/common/enums'
import { Activity } from '../../models/common/activity'
import { OpActor } from '../../models/core/op-actor'

import { LocalizationHelper } from '../../helpers/localization-helper'
import { TemplateHelper } from '../../helpers/template-helper'
import { ConfigHelper } from '../../helpers/config-helper'

import { ActorHelper } from './actors.helper'

export interface ActorScope extends ScopeBaseGrid {
    deleteConfirmationOptions: {
        title: string

        onConfirmed: () => void
    }
}

export class ActorController extends BaseGridController {

    // Members

    private grid: GridController<OpActor>

    // Members End


    constructor(
        protected $scope: ActorScope,
        $state: StateService,
        $timeout: ng.ITimeoutService,
        api: Api,
        private logger: LoggerService,
        localDictionary: LocalDictionaryFactory,
        protected userSession: UserSessionService,
        protected systemService: SystemService,
        referenctType: Enums.ReferenceType,
        private moduleName: Enums.SimaxModuleName
    ) {
        super($scope, $timeout, $state, userSession, systemService, api, localDictionary, null, referenctType)

        this.setConfirmationsOptions()
        this.setEvents()
        this.setMainGridOptions()
    }

    // Events 

    onInitialized(e: any, grid: GridController<OpActor>) {
        this.grid = grid
        this.dataGrid = e.component

        this.setGridId(e.tableId)
    }

    onAdd() {
        const createEditInitParams: CreateEditInitParams = {
            createEditSelectedTabType: Enums.SimaxCreateEditSelectedTabType.BaseParameters,
            groupReferenceType: null,
            groupReferenceValue: null,
            idReferenceType: this.referenceType,
            moduleName: this.moduleName,
            referenceObject: null,
            referenceObjectId: 0,
            sections: null,
            useBusinessObjects: true
        }

        this.$scope.$broadcast(EventsNames.INITIALIZE_CREATE_EDIT_POPUP, createEditInitParams)
    }

    onEdit() {
        if (this.dataGrid.getSelectedRowKeys().length == 1) {
            const createEditInitParams: CreateEditInitParams = {
                createEditSelectedTabType: Enums.SimaxCreateEditSelectedTabType.BaseParameters,
                groupReferenceType: null,
                groupReferenceValue: null,
                idReferenceType: this.referenceType,
                moduleName: this.moduleName,
                referenceObject: null,
                referenceObjectId: this.grid.selectedItemId,
                sections: null,
                useBusinessObjects: true
            }

            this.$scope.$broadcast(EventsNames.INITIALIZE_CREATE_EDIT_POPUP, createEditInitParams)
        } else {
            const columnCount = this.dataGrid.columnCount()
            const columns = []

            for (let i = 0; i < columnCount; i++) {
                columns.push(this.dataGrid.columnOption(i));
            }

            const bulkEditInitParams: BulkEditInitParams = {
                gridColumns: columns,
                groupReferenceType: null,
                groupReferenceValue: null,
                idReferenceType: this.referenceType,
                moduleName: this.moduleName,
                section: null,
                selectedGridRows: angular.copy(this.grid.selectedGridItems),
                useBusinessObjects: true
            }

            this.$scope.$root.$broadcast(EventsNames.INITIALIZE_BULK_EDIT_POPUP, bulkEditInitParams)
        }
    }

    onShowDetails(e: any) {
        const detailsOptions: DetailsOptions = {
            hasPermission: true,
            idReferenceType: this.referenceType,
            moduleName: this.moduleName,
            pageItemsIds: this.grid.pageItemsIds,
            referenceObjectId: this.grid.selectedItemId
        }

        this.showDetails(e, detailsOptions)
    }

    onDelete() {
        this.$scope.$broadcast(
            EventsNames.OPEN_CONFIRMATION_POPUP + this.$scope.popupId,
            LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__CONFIRM_DELETE, this.moduleName)
        )
    }

    onDeleted() {
        this.grid.dxGrid.refresh()
    }

    onConfirmDelete() {
        ActorHelper
            .deleteActor(this.userSession.getDataProvider(), this.grid.selectedItemId, this.moduleName)
            .then(() => {
                this.$scope.$root.$broadcast(EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__DELETED, this.moduleName))
            })
            .fail((error: any) => {
                this.logger.log(error)
            })
    }

    // Events End

    // Setup

    private getContextMenuItems(isTouchScreen: boolean = false): any[] {
        const items: any[] = [];

        if (this.userSession.getLoggedOperator().hasPermission(Activity.ACTOR_EDIT)) {
            items.push({
                beginGroup: true,
                template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Edit), ConfigHelper.Icon.EDIT, this.userSession),

                onItemClick: (e: any) => this.onEdit(),
            })
        }

        return this.mergeWithDefaultItems(isTouchScreen, items);
    }

    private getGridButtonsOptions(): ButtonsOptions {
        return {
            enabled: true,

            addPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.ACTOR_ADD) ? "['" + Activity[Activity.ACTOR_ADD] + "']" : null,
            deletePermissions: this.userSession.getLoggedOperator().hasPermission(Activity.ACTOR_DEL) ? "['" + Activity[Activity.ACTOR_DEL] + "']" : null,
            editPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.ACTOR_EDIT) ? "['" + Activity[Activity.ACTOR_EDIT] + "']" : null,
            exportPermissions: null,
            importPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.ACTOR_IMPORT_OP) ? "['" + Activity[Activity.ACTOR_IMPORT_OP] + "']" : null,
            saveColumnSettingsPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_MODULE_VIEW_COLUMN_DEFINITION_OP) ? "['" + Activity[Activity.WEBSIMAX_MODULE_VIEW_COLUMN_DEFINITION_OP] + "']" : null,
            showDetailsPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.ACTOR_LIST) ? "['" + Activity[Activity.ACTOR_LIST] + "']" : null,

            onAddClick: () => this.onAdd(),
            onDeleteClick: () => this.onDelete(),
            onEditClick: () => this.onEdit(),
            onShowClick: (e: any) => this.onShowDetails(e),
        }
    }

    private getImportOptions(): ImportOptions {
        return {
            dictionaryMethodName: 'getContactEditFields',
            popupName: i18n('Popup', 'ImportActors'),
            requestMethodType: 'contact',
            referenceType: this.referenceType,
            moduleName: this.moduleName,
            columnsReorderingDisabled: this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.ActorModuleMainGrid)
        }
    }

    private setConfirmationsOptions(): void {
        this.$scope.deleteConfirmationOptions = {
            title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DELETING, this.moduleName),

            onConfirmed: () => this.onConfirmDelete()
        }
    }

    private setEvents(): void {
        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__DELETED, this.moduleName),
            (event: ng.IAngularEvent, ...args: any[]) => this.onDeleted()
        )

        this.$scope.showDetails = (e: any) => this.onShowDetails(e)
    }

    private setMainGridOptions(): void {
        $.when(
            this.userSession
                .getDataProvider().System
                .getRequestColumnInfo(Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__GRID_PARAMS, this.moduleName),
            this.userSession
                .getDataProvider().System
                .getRequestColumnInfo(Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__DEFAULT_GRID_PARAMS, this.moduleName)
        )
            .then((columns: ColumnModel[], defaultColumns: ColumnModel[]) => {
                this.$scope.mainGridOptions = {
                    referenceId: this.referenceType,
                    idReferenceType: this.referenceType,
                    type: GridTypes.MAIN,
                    name: 'ActorsGrid',
                    addCustomFilters: true,
                    buttonsOptions: this.getGridButtonsOptions(),
                    columnsDictionary: columns,
                    dataSourceAdditionalFields: null,
                    defaultColumnsDictionary: defaultColumns,
                    importOptions: this.getImportOptions(),
                    localStorageVarForSavedEntity: CommonHelper.localStorageVarForSavedEntity.actorSaved,
                    preExecuteClearFilter: this.preExecuteGridClearFilter,

                    allowColumnReordering: !this.userSession
                        .getLoggedOperator()
                        .hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.ActorModuleMainGrid),

                    getDataSourceMethod: this.userSession
                        .getDataProvider().Actor.getActorFilter,

                    onInitialized: (e: any, grid: GridController<OpActor>) => this.onInitialized(e, grid),
                    onDataReady: (data: any) => this.onDataReady(data),
                    onRowDoubleClick: (e: any) => this.onShowDetails(e),
                    contextMenuItems: () => this.getContextMenuItems(),
                }
            })
    }
}
